import { useParams } from 'react-router-dom';
import { CalendarFrame } from 'components/CalendarTools';


export const CollabCalendarFullPage = () => {
    const { collabKey = "" } = useParams<{ collabKey: string }>();

    return (
        <CalendarFrame
            associated_type="collab"
            associated_uuid={collabKey}
            backTo={`/collab/${collabKey}`}
        />

    );
};

export default CollabCalendarFullPage;
